import { constructSearchObj } from "../../utils/utils";
import { SUPPLIERS_FETCH_SUPPLIERS } from "../action-types/suppliers-types";
import { axiosAction } from "../../utils/axiosAction";

const ENDPOINT = `${process.env.REACT_APP_ENDPOINT_SUPPLIERS}`;

export const getEntities = (params, meta?) => async dispatch => {
    return axiosAction.get(`${ENDPOINT}${constructSearchObj(params)}`,
        SUPPLIERS_FETCH_SUPPLIERS,
        dispatch,
        {
            meta
        }
    );
};
